module.exports = __webpack_public_path__ + "img/duet.2b27a716.png";